import { Slide } from "@mui/material";
const SlideLeft = (props: any) => <Slide {...props} direction="left" />;
export default SlideLeft;